import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import Alert from '../../../../components/Alert/Alert';
import { TicketContext } from '../../../../contexts/TicketContext';
import { TicketRoutePaths } from '../../../../interfaces/Routes';
import StepsService from '../../../../services/StepsService';
import styles from './ImproveMeterkast.module.scss';

const ImproveMeterkast: FC = () => {
  const { t } = useTranslation();
  const { ticket } = useContext(TicketContext);
  const navigate = useNavigate();

  if (!ticket) return null;

  const status = ticket.reportStatus;

  if (status === 'disabled') {
    return null;
  }

  const onImproveMeterkastClick = () => {
    navigate(StepsService.getStepUri(ticket.hashId, TicketRoutePaths.meterkast), { state: { hasPreviousPage: true } });
  };

  return (
    <section className={styles.meterkastScheduledSection}>
      {status === 'processing' && (
        <Alert
          className={styles.alert}
          icon="check_circle"
          level="success"
          subtext={t('meterkast:scheduledBody')}
          text={t('meterkast:scheduledTitle')}
        />
      )}

      {status === 'enabled' && (
        <Alert
          buttonStyle="button"
          className={styles.alert}
          icon="info"
          level="info"
          subtext={t('meterkast:ctaBody')}
          text={t('meterkast:ctaTitle')}
          textButton={{ onClick: onImproveMeterkastClick, text: t('meterkast:ctaButton') }}
        />
      )}
    </section>
  );
};

export default ImproveMeterkast;
